import React from 'react';

const ScheduleStatus = (interview) => {

    const getStatusName = (interview) => {
        // console.log(interview)
        let statusId = interview?.interview?.[0]?.status || 0;
      
        if (interview?.interview_cand_approval === 0) {
            statusId = -2 // Candidate rejected Interview
        }

        if (interview?.interview_cand_approval === 1 && interview?.interview.length > 0) {
            statusId = 7 // Candidate Accepted Interview
        }
     

        switch (statusId) {
            case 0:
                return (
                    <span className="text-black bg-gray-300 px-6 py-2 block w-full text-center">
                        Yet to accept
                    </span>
                );
            case 1:
                return (
                    <span className="bg-blue-700 px-6 py-2 text-white block w-full text-center">
                        Scheduled for Interview
                    </span>
                );
            case 2:
                return (
                    <span className="bg-lime-500 px-6 py-2 text-white block w-full text-center">
                        {/* Interviewer Accepted */}
                        Candidate sch. accptance pending
                    </span>
                );
            case 3:
                return (
                    <span className="bg-red-600 px-3 py-2 text-white block w-full text-center">
                        Interviewer Rejected Sch.
                    </span>
                );
            case 4:
                return (
                    <span className="bg-purple-600 px-3 py-2 text-white block w-full text-center">
                        Query raised by interviewer
                    </span>
                );
            case -2:
                return (
                    <span className="bg-red-600 px-3 py-2 text-white block w-full text-center">
                        Candidate Declined sch.
                    </span>
                );
            case 7:
                return (
                    <span className="bg-amber-600 px-3 py-2 text-white block w-full text-center">
                        Candidate Accepted sch.
                    </span>
                );
            case 5:
                return (
                    <span className="bg-green-700 px-3 py-2 text-white block w-full text-center">
                        Interview Completed
                    </span>
                );
            case 6:
                return (
                    <span className="bg-yellow-600 px-3 py-2 text-white block w-full text-center">
                        Ready for Next Level - schedule
                    </span>
                );
            case -1:
                return (
                    <span className="bg-orange-600 px-3 py-2 text-white block w-full text-center">
                        Re-scheduled Request
                    </span>
                );
            default:
                return '-';
        }
    };

    return getStatusName(interview);
};

export default ScheduleStatus;
